import { useState, useEffect, useRef, Fragment, memo, useMemo } from "react";
import style from "./../../../Modal/index.module.scss";
import styleUi from "./SearchTagFilter.module.scss";
import allStyle from "./../all.module.scss";
import { v4 } from "uuid";
import styled from "styled-components";
import { CSSTransition } from 'react-transition-group';
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
import Checkbox from '@mui/material/Checkbox';
import AppConfig from '../../../AppConfig';
const SearchTagFilter = ({ setModalType, arg }) => {
    const [inProp, setInProp] = useState(false);
    const [tags, set_tags] = useState(AppConfig.modeEnum.map(v=>{return {label:v.label,type:v.type,selected:false}}));
    useEffect(() => {
        console.log("SearchTagFilter");
        setInProp(true);
    }, [])
    const handleCheckboxChange = (index) => {
        set_tags((prevTags) => {
            const newTags = [...prevTags];
            newTags[index].selected = !newTags[index].selected;
            return newTags;
        });
    };
    const findPot = () => {
        const selectTags = tags.filter(v => v.selected);
        arg.cb(selectTags);
        setInProp(false)
    };
    return (
        <div className={style.modalBottom}>
            <CSSTransition in={inProp} timeout={{
                appear: 0,
                enter: 300,
                exit: 0,
            }} classNames={{
                enterActive: style.UpPageEnterActive,
                enterDone: style.UpPageEnterDone,
                exitActive: style.UpPageExit,
                exitDone: style.UpPageExitActive
            }}
            >
                <div className={`${style.UpPage}`} >
                    <CSSTransition in={inProp} timeout={{
                        appear: 0,
                        enter: 300,
                        exit: 0,
                    }} classNames={{
                        enterActive: style.UpPageEnterActive,
                        enterDone: style.UpPageEnterDone,
                        exitActive: style.UpPageExit,
                        exitDone: style.UpPageExitActive
                    }}
                        onExited={async () => {
                            await new Promise(resolve => requestAnimationFrame(resolve));
                            setModalType(prev => prev.filter(v => v.cls !== "SearchTagFilter"))
                        }}
                    >
                        <div className={`${style.UpPage} ${style.page}`} id="background" onClick={event => {
                            if (event.target.id == "background") {
                                //modalThrough 的話點不到 ，也不合理
                            }
                        }}>
                            <div className={styleUi.app}>
                                <div className={styleUi.head}>
                                    <div className={styleUi.bar}>
                                    </div>
                                </div>

                                <div className={styleUi.content}>
                                    <div className={styleUi.title}>
                                        篩選
                                    </div>
                                    <div className={styleUi.mode}>
                                        模式
                                    </div>
                                    <div className={styleUi.list}>
                                        {tags.map((v, k) => {
                                            return <div className={styleUi.item} key={k}>
                                                <span>{v.label}</span>
                                                <Checkbox checked={v.selected} onChange={() => handleCheckboxChange(k)} />
                                            </div>
                                        })}
                                    </div>
                                </div>
                                <IconButton className={styleUi.close} onClick={e => {
                                    setInProp(false)
                                }}>
                                    <CloseIcon />
                                </IconButton>
                                <div className={styleUi.bottom}>
                                    <button className={allStyle.btnWhite1} onClick={e => {
                                        set_tags((prevTags) => prevTags.map(tag => ({ ...tag, selected: false })));
                                    }}>
                                        重置
                                    </button>
                                    <button className={allStyle.btnBlack1} onClick={() => findPot()}>
                                        查看結果
                                    </button>
                                </div>
                            </div>
                        </div>
                    </CSSTransition>
                </div>
            </CSSTransition>
        </div>
    );
}

export default memo(SearchTagFilter);